// extracted by mini-css-extract-plugin
export default {"base":"EditLabelText_base__3GVOK"};